export default "__VITE_ASSET__CvluYDuZ__"